// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__mMoAR","root":"styles_root__3GpCZ","track":"styles_track__1JBlg","switchBase":"styles_switchBase__1SWsx","checked":"styles_checked__2cGIK"};